var t=function(t,e,n,o){var r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:1.333,a=((null==t?void 0:t.offsetWidth)-(e-1)*n)/e/r||0;return a&&0!==a&&a*o+n*o||0};export{t as default};
